import { DefaultFormatRegistry } from '@cs/common';

export class IJsmakerFormatRegistry extends DefaultFormatRegistry {

	constructor() {
		super();
		this.options.nullAsZero = false;
	}
}
